<template>
  <div class="flex-grow">
    <div :class="{'tree-height': bottomSpace} ">
      <v-text-field
        v-model="search"
        label="Search Iconography Tree"
        hide-details
        clearable
        clear-icon="mdi-close-circle-outline" ></v-text-field>
      <v-treeview
      ref="tree"
        id="annoTree"
        selection-type="leaf"
        :filter="filter"
        :search="search"
        return-object
        v-model="icoSelected"
        rounded
        selectable
        hoverable
        :open-all = "true"
        :items="this.icoAnnos"
        dense
        multiple-active
        :active="allActiveIcos"
      >
        <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
          <div
            class="inline"
            @click="clickAnno(item)"
            @mouseover="mouseOverNode(item)"
            @mouseleave="mouseLeaveNode(item)"
          >
          <div :id="itemId + '-tree1-iconographyID-'+item.iconographyID" class="v-treeview-node__label">
            <span style="margin-right: 5px;">{{ item.name}}</span> <v-tooltip top> <template v-slot:activator="{ on, attrs }"><a v-bind="attrs" v-on="on" style="min-width: 54px;" :href="getIconographyLink(item)" target=”_blank”>[see more]</a></template><span>Get more information and related entries to this element.</span></v-tooltip>
          </div>
        </div>
        </template>
      </v-treeview>
    </div>
  </div>
</template>
<script>
import {deviceType, getIconographyByAnnos, getIconographyByAnnosInGivenTree, getIco, getIconographyByID} from  "@/utils/helpers"
import {getIconogrpaphyByTimestamp} from '@/services/repository'
import { v4 as uuidv4 } from 'uuid';
import * as d3 from "d3";


export default {
  name: 'AnnotatedImageTree',
  components: {
  },
  props: {
    bottomSpace: {
      type: Boolean,
      default: false
    },
    preselectedIcos: {
      type: Array,
      default: function () {
        return []
      }
    },
    annos: {
      type: Array
    },
    relatedAnnotations: {
      type: Array,
      default: function () {
        return []
      }
    },
    highlightedIcos: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  emits: ['clickAnno', 'mouseOverNode', 'mouseLeaveNode'],
  data () {

    return {
      icoAnnos: [],
      icoSelected: [],
      icoActivated: [],
      search: null,
      uniqueID: uuidv4(),
      isMounted: false,
    }
  },
  computed: {
    allActiveIcos() {
      return [...this.highlightedIcos, ...this.icoActivated]
    },
    deviceType(){
      this.$log.debug("deviceType", deviceType())
      return deviceType()
    },
    user () {
      return this.$store.state.user
    },
    isTouchDevice() {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    },
    itemId(){
      return this.uniqueID
    },
    filter () {
      return  (item, search, textKey) => {
        if (item.search) {
          // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          return (item["search"].toLowerCase().normalize("NFD").indexOf(search) > -1 || item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        } else {
          return (item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        }
      }
    },
  },
  methods: {
    mouseOutAnnotation(annotation){
      this.icoActivated = []
      this.hoveredAnno = null
    },
    mouseEnterAnnotation(annotation){
      if (!annotation.id) return
      this.$log.debug("mouseEnterAnnotation", annotation)
      const treeElement = document.getElementById(this.itemId + '-tree1-iconographyID-' + annotation.body[0].id)
      if (!this.isTouchDevice || (this.isTouchDevice && this.actControl === "Navigate")){
        let annos = []
        this.$log.debug("treeElement", treeElement)
        // deactivated in new design
        // if (treeElement){
        //   treeElement.scrollIntoView({"behavior":"smooth", "block": "nearest"})
        // }
        // this.$vuetify.goTo('#tree2-iconographyID-' + annotation.body[0].id, gotoOptions)
        const tree2Element = document.getElementById(this.itemId + '-tree2-iconographyID-' + annotation.body[0].id)
        if (tree2Element){
          tree2Element.scrollIntoView({"behavior":"smooth", "block": "nearest"})
        }
        for (let anno of annotation.body){
          if (Array.isArray(this.icoAnnos)){
            for (let ico of this.icoAnnos){
              let res = getIco(ico, anno.id)
              if (res !== null){
                annos.push(res)
                // this.$log.debug("adding annos:", res);
                break
              }
            }
          } else {
            let res = getIco(this.icoAnnos, anno.id)
            if (res !== null){
              annos.push(res)
            }
          }
        }
        for (let anno of annos){
          this.icoActivated.push(anno)
        }
        this.hoveredAnno = annotation
        this.showTag = true
        // this.updateSelectedAnnos()
        setTimeout(function(){ this.showTag = false}, 5000);
      }
      return treeElement
    },
    initTree(doW3c){
      if (doW3c){
        var allAnnotationEntries = []
        this.w3cAnnos = []
        var geoGenerator = d3.geoPath()
        for (var ae of this.relatedAnnotations) {
          for (var ico of ae.tags) {
            if (!allAnnotationEntries.includes(ico)) {
              allAnnotationEntries.push(ico.iconographyID);
            }
          }
          // It happened, that sometimes, w3c Annotations were not properly converted. In this cases, just the string representation of the w3c-object was stored. To allow to present the annotation anyway, the system tests here for the String-representation to prevent errors. Do: check, if '[object Object]' is still produced or if this is has just been a left over.
          if (ae.w3c && ae.w3c !==  "[object Object]"){
            if (typeof ae.w3c === 'string' || ae.w3c instanceof String) {
              this.w3cAnnos.push(JSON.parse(ae.w3c))
            } else {
              this.w3cAnnos.push(ae.w3c)
            }
          } else {
            var bodies = []
            for (var ie of ae.tags) {
              if (!allAnnotationEntries.includes(ie)) {
                var body = {};
                body["type"] = "TextualBody";
                if (ie.name){
                  body["value"] = ie.name;
                } else {
                  body["value"] = ie.text;
                }
                body["id"] = ie.iconographyID;
                body["image"] = ae.image;
                bodies.push(body);
              }
            }
            var anno = {};
            anno["@context"] = "http://www.w3.org/ns/anno.jsonld";
            anno["id"] = ae.annotoriousID;
            anno["type"] = "Annotation";
            anno["motivation"] = "highlight"
            anno["body"] = bodies;
            var target = {};
            var selector = {};
            selector["type"] = "SvgSelector";
            selector["conformsTo"] = "http://www.w3.org/TR/media-frags/";
            var root
            if (ae.polygon){
              root = JSON.parse(ae.polygon);
            } else {
              root = JSON.parse(ae.geoJson);
            }
            selector["value"] = "<svg><path d=\"" + geoGenerator(root) + "\"></path></svg>";
            target["selector"] = selector;
            target["id"] = ae.image
            anno["target"] = target;
            this.w3cAnnos.push(anno);

          }
        }
        const _self = this
        if (this.isVersion){
          if (this.isVersion.date.toString().includes('current')){
            this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)
          } else {
            getIconogrpaphyByTimestamp(this.isVersion._source.timestamp)
              .then( res => {
                _self.icoAnnos = getIconographyByAnnosInGivenTree(allAnnotationEntries, res.data.hits.hits[0]._source.content.iconographyTree)
              }).catch(function (error) {
                _self.$log.debug(error)
                return null
              })
            this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)

          }
        } else {
          this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)
        }
        for (let w3cAnno of this.w3cAnnos){
          this.putW3cInAnnos(w3cAnno)
        }

      }
      this.$refs.tree.updateAll(true)
    },
    putW3cInAnnos(anno){
      for (let rootItem of this.icoAnnos){
        this.findInTree(rootItem, anno)
      }
    },
    mouseOverNode(item){
      this.$nextTick(() => {
        this.$emit('mouseOverNode', item)
      })
    },
    mouseLeaveNode(item){
      this.$emit('mouseLeaveNode', item)

    },
    findElementinTree(element, tree){
      if (element.iconographyID === tree.iconographyID){
        return tree
      } else {
        for (let child of tree.children){
          let res = this.findElementinTree(element, child)
          if (res !== null){
            return res
          }
        }
        return null
      }
    },
    getIconographyLink(item){
      return window.location.origin  + "/iconography/" + item.id
    },
    clickAnno(item){
      let found = false
      let filteredAnnos = []
      for (let anno of this.icoSelected){
        if (anno.id === item.id){
          found = true
        } else {
          filteredAnnos.push(anno)
        }
      }
      if (found) {
        this.icoSelected = filteredAnnos
      } else {
        this.icoSelected.push(item)
      }
    },
    handleClick(event){
      this.$log.debug("click!", event);
      if (event.pointerType === "touch"){
        this.$log.debug("is touch");
      }
    },

    enableTree() {
      for (let rootItem of this.icoAnnos){
        rootItem.locked = false
      }
    },
    findInTree(element, w3cAnno){
      for (let body  of w3cAnno.body){
        if (body.id === element.iconographyID){
          element.w3cAnno.push(w3cAnno)
        }
      }
      for (let child of element.children){
        this.findInTree(child, w3cAnno)
      }
    },
    selectChildren(parent){
      for (let child of parent.children){
        this.selectChildren(child)
        this.icoSelected.push(child)
      }
    },
    deselectChildren(parent){
      for (let child of parent.children){
        this.deselectChildren(child)
        const index = this.icoSelected.indexOf(child);
        if (index > -1) {
          this.icoSelected.splice(index, 1);
        }
      }
    },
    findIcoByID(id){
      for (let ico of this.icoAnnos){
        this.$log.debug("comparing ", id, ico.iconographyID)
        if (ico.iconographyID === id){
          return ico
        }
        for (let child of ico.children){
          let res = this.findIcoByIDinChildren(id, child)
          if (res !== null){
            return res
          }
        }
      }
      return null
    },
    findIcoByIDinChildren(id, ico){
      this.$log.debug("comparing ", id, ico.iconographyID)
      if (ico.iconographyID === id){
        return ico
      }
      for (let child of ico.children){
        let res = this.findIcoByIDinChildren(id, child)
        if (res !== null){
          return res
        }
      }
      return null
    },
  },
  watch: {
    'preselectedIcos': function(newVal, oldVal) {
      this.icoSelected = this.preselectedIcos.map(x => getIconographyByID(x))
      for (let id of newVal){
        const item = this.findIcoByID(parseInt(id, 10))
        this.$emit('mouseOverNode', item)
        this.clickAnno(item)
      }
      this.$log.debug("preselectedIcos changed", newVal[0],  this.icoSelected,  this.findIcoByID(parseInt(newVal[0], 10)))

    },
    'icoSelected': function(newVal, oldVal) {
      this.$emit('clickAnno', newVal)


    },
    'anno': function (newVal, oldVal) {
      if (this.isMounted){
      }
    },
    'relatedAnnotations':function (newVal, oldVal) {
      this.initTree(true)
    },
    'item': function (newVal, oldVal) {
      this.initTree(true)
    },
    'icoActivated': function(newVal, oldVal) {
    },
    'annos': function(newVal, oldVal) {
      if (this.isMounted){
      }
    },

  },
  created () {
  },
  beforeDestroyed () {
  },
  beforeMount:function(){

  },
  updated:function () {
    this.$refs.tree.updateAll(true)
  },
  mounted:function () {
    this.isMounted = true
    this.initTree(true)
  },
  beforeDestroy:function () {
  }
}
</script>

<style lang="css" >
.flex-grow {
  display: flex !important;
  flex-direction: column;
  flex-grow: 1;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: rgba(255, 255, 255, 0.0) !important;
}
.a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0.25);
  stroke-width:0px;
  display: inline !important;
}
.a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
  display: inline !important;
}
.hidden {
  visibility: hidden;
}

.visible {
  visibility: visible;
}
#instructions {
  pointer-events: none!important;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.a9s-annotation.highlight .a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0.25)!important;
  stroke-width:0px!important;
}

.a9s-annotation.highlight .a9s-outer:hover {
  transition: fill 1s, stroke-width 0.7s;
  stroke-width:0px;
  fill: rgba(255, 255, 255, 0);
}
.a9s-annotation.highlight .a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
}
.a9s-annotation.hide .a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
}

.a9s-annotation.hide .a9s-outer:hover {
  transition: fill 1s, stroke-width 0.7s;
  stroke-width:0px;
  fill: rgba(255, 255, 255, 0);
}
.a9s-annotation.hide .a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  fill: rgba(255, 255, 255, 0);
  stroke-width:0px;
}

.a9s-annotation.hide .a9s-inner:hover {
  stroke: #fff000;
  vector-effect: none;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
  transition: fill 1s, stroke-width 0.7s;
}
.tree-height{
}
.inline {
  display: flex;
}
</style>
